import axios from "axios";
import { server2, port2 } from "./environment";
import VueCookies from "vue-cookies";
export default () => {
  return axios.create({
    baseURL: `${server2}:${port2}/api/`,
    headers: {
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin': '*',
      Authorization: "Bearer " + $cookies.get("token")
    }
  });
};
